import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PageContentModel } from 'src/app/models/page-content.model';

@Component({
    selector: 'app-generic-paragraph',
    templateUrl: './generic-paragraph.component.html',
    styleUrls: ['./generic-paragraph.component.scss'],
    standalone: false
})
export class GenericParagraphComponent implements OnInit {

  @Input() pageContent: PageContentModel

  title: string
  content: string

  public currentLang: string

  constructor(public translateService: TranslateService) {
    this.currentLang = translateService.currentLang

    translateService.onLangChange.subscribe(lang => {
      this.setTextByLanguage(lang.lang)
    })}

  ngOnInit(): void {
    this.setTextByLanguage(this.currentLang)
  }

  setTextByLanguage(lang: string){
    if (lang == 'en'){
      this.title = this.pageContent.Title
      this.content = this.pageContent.Content
    } else {
      this.title = this.pageContent.TitleFr
      this.content = this.pageContent.ContentFr
    }
  }

}
